/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { SyncErrorBanner } from './SyncErrorBanner';
const meta = {
    title: 'Features/Settings/Integrations/SyncErrorBanner',
    component: SyncErrorBanner,
    parameters: {
        layout: 'padded'
    },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: '600px', margin: '40px auto' } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const WithMessage = {
    args: {
        errorCategory: {
            category: 'materials',
            lastSuccessAt: '2025-06-08T10:00:00Z',
            lastErrorAt: '2025-06-10T14:30:00Z',
            lastErrorMessage: 'QuickBooks returned a 401 — token may have expired. Re-connect the integration.'
        }
    }
};
export const NoMessage = {
    args: {
        errorCategory: {
            category: 'customers',
            lastSuccessAt: null,
            lastErrorAt: '2025-06-10T09:00:00Z',
            lastErrorMessage: null
        }
    }
};
